import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import axios from "axios";
import Navigation from "../home/Navigation";
import Header from "../home/Header";
import AdminLayout from "../home/AdminLayout";
import {
  URL,
  verificarRol,
  administradorEmpresas,
  gestorEmpresa,
  empleado,
  iscertLoguin,
  firmaRL,
  reportes, username, idEmpresa
} from "../../constans/constants";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import FirebasePushListener from "../notificacion/FirebasePushListener";
import { sessionData } from "../login/SesionService";

function renderLayout(layout, Component, props, layoutProps, tituloSeccion) {
  if (layout === "none") {
    return <Component {...props} />;
  }
  if (layout === "admin") {
    return (
      <AdminLayout tituloSeccion={tituloSeccion}>
        <Component {...props} />
      </AdminLayout>
    );
  }
  return (
    <FullLayout {...layoutProps}>
      <Component {...props} />
    </FullLayout>
  );
}

const PrivateRoute = ({
  sessionData,
  layout = "full", // "full" o "none"
  roles,
  component: Component,
  ...rest
}) => {
  const cookies = new Cookies();
  let logged = cookies.get("logged") === "true";
  if (logged) {
    let rolesData = JSON.parse(localStorage.getItem("roles"));
    if (
      rolesData != null &&
      rolesData.hasOwnProperty("id") &&
      rest.rol != null) {
      if (verificarRol(rolesData, rest.rol)) {
        return (
          <Route
            {...rest}
            render={(props) => {
              const { location } = props;
              const mensajeFlash = location.state?.mensajeFlash || "";
              const mostrarMensajeFlash = location.state?.mostrarMensajeFlash || false;
              const mensajeFlashSeverity = location.state?.mensajeFlashSeverity || "neutral";

              const layoutProps = {
                mensajeFlash,
                mostrarMensajeFlash,
                mensajeFlashSeverity,
              };

              return renderLayout(layout, Component, props, layoutProps, rest.tituloSeccion);
            }}
          />
        );
      } else {
        return <Redirect to="/error"/>
/*
        if (verificarRol(rolesData, gestorEmpresa)) {
          return <Redirect to="/lote/nuevos" />;
        } else {
          if (verificarRol(rolesData, empleado)) {
            return <Redirect to="/bandeja/pendientes" />;
          } else if (verificarRol(rolesData, administradorEmpresas)) {
            return <Redirect to="/usuarios" />
          } else if (verificarRol(rolesData, firmaRL)) {
            return <Redirect to="/lote/firmados" />
          } else if (verificarRol(rolesData, reportes)) {
            return <Redirect to="/reporte/recibo-colaborador/todos" />
          }
        }
*/
      }

    } else {
      return <Route {...rest} render={(props) =>
        renderLayout(layout, Component, props, {}, rest.tituloSeccion)} />;
    }
  } else {
    if (iscertLoguin) {
      axios.get(URL + "auth").then((res) => {
        window.location.replace(res.data);
      });
    } else {
      return <Redirect to="/login" />
    }
  }
};

const FullLayout = ({ children, mensajeFlash, mostrarMensajeFlash, mensajeFlashSeverity }) => {
  return (
    <>
      <div className="template-dashboard">
        <div className="wrapperDashboard">
          <Navigation />
          <main className="main-container">
            <Header />
            <FirebasePushListener username={username()} empresaId={idEmpresa()} />
            <div className="innerContainer">{children}</div>
          </main>
        </div>
        <MensajeFlash
          visible={mostrarMensajeFlash}
          mensaje={mensajeFlash}
          severity={mensajeFlashSeverity}
        />
      </div>
    </>
  );
};



const mapStateToProps = (state) => ({
  sessionData: state.sessionData,
  roles: state.rolesData,
});

export default connect(mapStateToProps)(PrivateRoute);
